import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TabsModule} from '@components/tabs/tabs.module';
import {SpecialistDataFlowService} from './services/specialist-data-flow.service';
import {SpecialistViewLayoutComponent} from './specialist-view-layout/specialist-view-layout.component';
import {LayoutModule} from '@layoutComponents/layout.module';
import {SpecialistViewCommonComponent} from './specialist-view-common/specialist-view-common.component';
import {ServiceFormatterPipeModule} from '@pipes/serviceFormatter.module';
import {ModalModule} from '@components/modal/modal.module';
import {FilePreviewModule} from '@components/file-preview/file-preview.module';
import {SpecialistViewTabNkComponent} from './specialist-view-tab-nk/specialist-view-tab-nk.component';
import {ToRomanPipeModule} from '@pipes/toRoman.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {SpecialistViewTabPbComponent} from './specialist-view-tab-pb/specialist-view-tab-pb.component';
import {SpecialistViewTabEducationComponent} from './specialist-view-tab-education/specialist-view-tab-education.component';
import {SpecialistViewTabClothesComponent} from './specialist-view-tab-clothes/specialist-view-tab-clothes.component';

@NgModule({
    imports: [
        CommonModule,
        TabsModule,
        LayoutModule,
        ServiceFormatterPipeModule,
        ModalModule,
        FilePreviewModule,
        ToRomanPipeModule,
        DirectivesModule,
    ],
    exports: [
        SpecialistViewLayoutComponent,
    ],
    declarations: [
        SpecialistViewLayoutComponent,
        SpecialistViewCommonComponent,
        SpecialistViewTabNkComponent,
        SpecialistViewTabPbComponent,
        SpecialistViewTabEducationComponent,
        SpecialistViewTabClothesComponent,
    ],
    providers: [
        SpecialistDataFlowService,
    ],
})
export class SpecialistViewModule {
}
